/*
 * Module for the participant common area menu
*/

rs.module("application/sections/participant/commonarea/commonareaquickmenu",

    ["ui/framework/client-templates"],

    function (clientTemplates) {

        var _jsSelectors;
        var _cssClasses;
        var _isInitialized = false;

        //
        // Initialize
        //
        function initialize(jsSelectors, cssClasses, backendUrls, templateKeys, menuItemKeysToLoadOnOpen) {

            var menu = $.js(jsSelectors.menu, { required: false });

            // If there are no menu items, then we are suppressing the menu
            // We need to make sure them menu exists before initializing everything
            if (menu.length > 0) {

                _jsSelectors = jsSelectors;
                _cssClasses = cssClasses;
                _isInitialized = true;

                // kick off the retrieve to get the work count for the participant
                $.get(backendUrls.getParticipantWorkCount).done(function (result) {

                    // show the work count if there is any work
                    if (result.workCount > 0) {
                        menu.js(jsSelectors.countBubble).html(result.workCount).show();
                    }
                });

                var menuItems = menu.js(jsSelectors.menuItem, { multiple: true });

                // When the menu toggle is clicked show/hide the menu
                menu.js(jsSelectors.menuToggle).click(function () {

                    // close the id card when the menu opens
                    rs.module("application/sections/participant/commonarea").closeIdCard();

                    // add/remove active styling to menu toggle
                    $(this).toggleClass(cssClasses.active);

                    // open/close the menu
                    menu.js(jsSelectors.dropDownContainer).toggle();

                    // If the menu is being opened (i.e. the menu toggle has the class "_active")
                    if ($(this).hasClass(cssClasses.active)) {

                        // Get the currently selected (active) menu item
                        var activeMenuItem = menuItems.filter(`.${cssClasses.active}`);

                        // If there isn't one, get the first menu item in the drop down and select it.
                        if (activeMenuItem.length == 0) {

                            activeMenuItem = menuItems.first();
                            activeMenuItem.addClass(cssClasses.active);
                        }

                        LoadPopout(activeMenuItem, true);

                        // Start loading any popouts that have been marked to load on open.
                        // This needs to be in a set timeout so that it's not happening as the menu is opening.
                        // LoadPopout() won't show the popout right away, but it still appends it to the DOM.
                        // Doing this as the menu is opening creates a lag/choppy opening animation.
                        // Adding a slight delay alows the menu to open smoothly and then the popouts start getting added.
                        setTimeout(function () {
                            for (let key in menuItemKeysToLoadOnOpen) {
                                LoadPopout(menuItems.filter(`[data-menu-item-key=${menuItemKeysToLoadOnOpen[key]}]`), false);
                            }
                        }, 300);
                    }
                });

                // When a menu item is clicked, open the corresponding popout
                menuItems.click(function () {

                    // remove active class from any active menu items
                    menuItems.removeClass(cssClasses.active);

                    // add the active class to the menu item that was clicked
                    $(this).addClass(cssClasses.active);

                    LoadPopout(this, true);
                });

                //
                // Load the popout for the given menu item, and optionally open it
                //
                function LoadPopout(menuItem, openPopout) {

                    var menuItemKey = $(menuItem).data("menu-item-key");
                    var popoutUrl = $(menuItem).data("popout-url");
                    var title = $(menuItem).data("title");

                    var popouts = menu.js(jsSelectors.popout, { multiple: true, required: false });

                    if (openPopout) {

                        // if we are opening, first hide all popouts
                        popouts.removeClass(cssClasses.active);
                    }

                    // get the popout for this menu item
                    var popout = popouts.filter(`[data-menu-item-key=${menuItemKey}]`);

                    // check if the menu item already has a popout created
                    if (popout.length > 0) {

                        if (openPopout) {

                            // if popout exists, show it 
                            popout.addClass(cssClasses.active);
                        }
                    }
                    else {

                        // if popout doesn't exist, create it
                        var newPopout = $(clientTemplates.render(templateKeys.popout,
                            {
                                "menuItemKey": menuItemKey,
                                "title": title != "" ? title : "Loading..."
                            }));

                        // Add the popout to the drop down container
                        menu.js(jsSelectors.dropDownContainer).append(newPopout);

                        if (openPopout) {

                            // Show the popout 
                            // The setTimeout is necessary because we just added the newly created popout to the DOM
                            // If we were to just add the class, it would not slide in like existing popouts.
                            setTimeout(function () {
                                newPopout.addClass(cssClasses.active);
                            }, 0);
                        }

                        // make backend call to load popout content
                        $.get(popoutUrl).done(function (result) {

                            newPopout.js(jsSelectors.popoutContent).html(result);

                        }).fail(function () {

                            newPopout.js(jsSelectors.popoutContent).html(clientTemplates.render(templateKeys.popoutError,
                                {
                                    "title": title
                                }));
                        });
                    }
                }
            }            
        }

        //
        // Exported function to allow other js modules to close the menu
        //
        function closeMenu() {

            if (_isInitialized) {

                var menu = $.js(_jsSelectors.menu);
                menu.js(_jsSelectors.menuToggle).removeClass(_cssClasses.active);
                menu.js(_jsSelectors.dropDownContainer).hide();
                menu.js(_jsSelectors.popout, { multiple: true, required: false }).removeClass(_cssClasses.active);
            }
        }

        // Exported public API
        var exports = {
            initialize,
            closeMenu
        };

        return exports;
    }
);